import React from "react";
import { TextInput } from "react-native";

import { DateControlProps } from "./DateControl.types";
import { DateTimePicker } from "../../";

export const DateControl = React.forwardRef(
  <T, P extends Date>(
    {
      getValidationClassName,
      control,
      formState,
      value,
      label,
      required = false,
      error,
      onDateChange,
      props,
    }: DateControlProps<T, P>,
    ref: React.Ref<TextInput>
  ): React.ReactElement => {
    return (
      <DateTimePicker
        {...props}
        isOptional={!required}
        label={label}
        disabled={!!control.disabledIf && control.disabledIf(formState)}
        state={getValidationClassName().state}
        message={error || ""}
        value={value}
        onChange={onDateChange}
      />
    );
  }
);
